import * as types from './types';
import { loading } from 'State/actions';

export const getMonthlyClaimFormReport = data => {
  return async (dispatch, getState, MPWWebAPI) => {
    dispatch(loading(types.MONTHLY_CLAIM_FORM_LOADING, true));

    try {
      const response = await MPWWebAPI.postGenericInsertUpdate(
        'Reports/monthlyClaimForm',
        data
      );
      dispatch({
        type: types.MONTHLY_CLAIM_FORM_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.MONTHLY_CLAIM_FORM_LOAD_ERROR,
        error: error.response.Errors,
      });
    }

    dispatch(loading(types.MONTHLY_CLAIM_FORM_LOADING, false));
  };
};

export const clearReport = () => {
  return {
    type: types.MONTHLY_CLAIM_FORM_GET_REPORT,
    payload: null,
  };
};

export const clearErrors = () => {
  return {
    type: types.MONTHLY_CLAIM_FORM_CLEAR_ERRORS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/monthlyclaimform/state/report/actions.js